import styled from '@emotion/styled'

import { Flex, FullWidthFlex, pxToRem } from '@cash-design-system/react'

const CircleOutline = styled(Flex)`
  /* TODO(FSWEB-10875): Match border color to designs once know how to make it not disappear in dark mode. */
  border: ${pxToRem(1.5)} solid ${props => props.theme.colors.formFieldBackground};
  border-radius: 50%;
  height: 3rem;
  width: 3rem;
`

export const IconWithOutline = ({ icon }: { icon: React.ReactElement }) => {
  return (
    <CircleOutline>
      <FullWidthFlex justifyContent="center" alignItems="center">
        {icon}
      </FullWidthFlex>
    </CircleOutline>
  )
}
